const clearVariantControlPromo = (): void => {
    for (const [key] of Object.entries({ ...localStorage })) {
        if (key.includes('geoLocationPromoGroup:')) {
            localStorage.removeItem(key);
        }
    }
};

export default clearVariantControlPromo;
